import { Component, OnInit } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
    selector: 'app-webinar',
    templateUrl: './webinar.component.html',
    styleUrls: ['./webinar.component.css'],
    animations: [
        trigger('fadeInOut', [
            state('open', style({
                opacity: 1,
                transform: 'scale(1)'
            })),
            state('closed', style({
                opacity: 0,
                transform: 'scale(0.8)'
            })),
            transition('closed => open', [
                animate('0.3s ease-in-out')
            ]),
            transition('open => closed', [
                animate('0.2s ease-in-out')
            ])
        ])
    ],
    standalone: false
})
export class WebinarComponent {

  constructor() { }


  showCalendar: boolean = false;
  modalState: string = 'closed';
  activeTab: string = 'upcoming';

  events = [
    { date: 'From: 13/08/2025 Till: 19/08/2025 ', title: "Python Adventures | Free Webinar", time: "07:00PM", type: "upcoming",link: "https://www.sehyog.co.uk/11plus-help-club/category/workshop/f4a85009fed710698c8a338ff7d706b3" },
    { date: 'From: 15/08/2025 Till: 26/08/2025 ', title: "GCSE Admissions 2025 | Free Webinar ", time: "07:00PM", type: "upcoming",link: "https://www.sehyog.co.uk/11plus-help-club/category/workshop/2eed5585ff7658ea58c7bce6d2bfa7ce" },
    { date: 'From: 15/08/2025 Till: 29/08/2025 ', title: "11+ Breakthrough|Free Webinar", time: "07:00PM", type: "upcoming",link: "https://www.sehyog.co.uk/11plus-help-club/category/workshop/5c70cc85bd7fe003b51ab9caa1173d4b" },
  ];

  get filteredEvents() {
    return this.events.filter(event => event.type === this.activeTab);
  }

  setActiveTab(tab: string) {
    this.activeTab = tab;
  }

   // Open with animation
   openCalendar() {
    this.showCalendar = true;
    setTimeout(() => {
      this.modalState = 'open';
    }, 10);
  }

  // Close with animation
  closeCalendar() {
    this.modalState = 'closed';
    setTimeout(() => {
      this.showCalendar = false;
    }, 200); // Match the closing animation duration
  }

  

}
